import {
  CheckboxOption,
  UIInputCheckboxGroup,
  UIInputContainer,
} from "@endya-conformite/ui-kit";

type FilterMultiSelectProps<T extends string | number> = {
  name: string;
  label: string;
  value: T[];
  onChange: (value: T[]) => void;
  options: CheckboxOption<string>[];
  parseValue?: (raw: string) => T;
};

export function FilterMultiSelect<T extends string | number>({
  name,
  label,
  value,
  onChange,
  options,
  parseValue,
}: FilterMultiSelectProps<T>) {
  const stringValues = value.map((v) => String(v));
  return (
    <UIInputContainer name={name} label={label} hideError>
      <UIInputCheckboxGroup
        name={name}
        hasError={false}
        value={stringValues}
        options={options}
        onChange={(e: { target: { value: string[] } }) => {
          const parsed = parseValue
            ? e.target.value.map(parseValue)
            : (e.target.value as T[]);
          onChange(parsed);
        }}
      />
    </UIInputContainer>
  );
}
